import { BasicSearchCriteria } from "./BasicSearchCriteria";
import { ImageCopyright } from "./ImageCopyright";
import { ImageReference } from "./ImageReference";
import { ImageType } from "./ImageType";
import { PlantDataSource } from "./PlantDataSource";
import { PlantLocation } from "./PlantLocation";
import { SearchCriteria } from "./SearchCriteria";
import { SearchFilteringOption } from "./SearchFilteringOption";

export class ImageSearchCriteria extends SearchCriteria {
  public Countries: PlantLocation[];
  public Provinces: PlantLocation[];
  public Counties: PlantLocation[];
  public Cities: PlantLocation[];
  public Localities: PlantLocation[];
  public ArtistFirstLetters: string[];
  public ImageLocations: PlantLocation[];
  public Artists: PlantDataSource[];
  public CopyrightStatuses: ImageCopyright[];
  public ImageReferences: ImageReference[];
  public ImageTypes: ImageType[];
  public SortBy: string;
  public Offset: number;
  public FilterOptions: SearchFilteringOption[];
  public UnfilteredPlantIds: number[];
  public TaxonSearchCriteria: BasicSearchCriteria;

  constructor(
    Countries: PlantLocation[] = [],
    Provinces: PlantLocation[] = [],
    Counties: PlantLocation[] = [],
    Cities: PlantLocation[] = [],
    Localities: PlantLocation[] = [],
    ArtistFirstLetters: string[] = [],
    ImageLocations: PlantLocation[] = [],
    Artists: PlantDataSource[] = [],
    CopyrightStatuses: ImageCopyright[] = [],
    ImageReferences: ImageReference[] = [],
    ImageTypes: ImageType[] = [],
    SortBy: string = null,
    Offset: number = null,
    FilterOptions: SearchFilteringOption[] = null,
    UnfilteredPlantIds: number[] = null,
    TaxonSearchCriteria: BasicSearchCriteria = null
  ) {
    super(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      Countries,
      Provinces,
      Counties,
      Cities,
      Localities,
      ArtistFirstLetters,
      ImageLocations,
      Artists,
      CopyrightStatuses,
      ImageReferences,
      ImageTypes,
      SortBy,
      Offset,
      FilterOptions,
      UnfilteredPlantIds,
      null,
      TaxonSearchCriteria,
      -1
    );
  }
}
